import React, { Fragment, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import {
  Row, Col,
  Modal, ModalHeader, ModalBody, Card, CardBody, Table
} from "reactstrap";
import { getAllRole, getTicketHistory } from '../../../api';
import formatedDate from '../../../utilities/formatedDate';
import { getFromLocalStorage } from '../../../hooks/useLocalStorage';


const TicketHistory = (props) => {
  const { data } = props;
  const ticketNumber = data?.ticketNumber;
  const ticketStatus = data?.status;
  const [ticketHistoryData, setTicketHistoryData] = useState();
  const [ticketHierarchyLeft, setTicketHierarchyLeft] = useState();
  const [rowPayload, setRowPayload] = useState();
  const [rejectedFlag, setRejectedFlag] = useState(false);
  const [allRoles, setAllRoles] = useState();
  const [adminColumn] = useState(getFromLocalStorage('ROLE')?.key == "ADMIN" ? true : false);

  // console.log('data.payload', json/ JSON.stringify(data.payload));
  // console.log('data.payload type', typeof data.payload);
  // let payload = JSON.parse(data.payload);

  // console.log('data.XYZ', payload);


  // Extract and print cancellation_reason and sale id
  // console.log('Cancellation Reason:', payload.accept[0].Body.cancellation_reason);
  // console.log('Sales Policy certificate:', payload.accept[0].updateCriteria.sales_certificate_no);

  // const payload = JSON.parse('[{"moduleName":"sales","schemaName":"policySchema","Body":{"cancellation_reason":"hsdhsjdhsjdhjsd","is_active":false,"status":"CANCELLED"},"updateORcreate":1,"updateCriteria":{"sales_policy_id":"1"}}]');
  // console.log('parse payload', payload);

  // getTicketHistory();
  const fetchTicketHistory = async (ticketNumber) => {

    try {

      // console.log(dataPayLoad, 'dataPayLoad');
      const data = await getTicketHistory(ticketNumber)

      console.log("data.data.result.result", data.data.result);
      

      setTicketHistoryData(data.data.result.result)
      setTicketHierarchyLeft(data.data.result.hierrachyLeft);

    } catch (error) {
      // console.log("Catch Error", error?.response?.data?.error)
      console.log("Catch Error", error)
      toast.info('API : ' + error?.response?.data?.error)
      // setIsLoading(false);

    }
  };



  useEffect(() => {
    // getTicketHistory();
    if (ticketNumber) {
      fetchTicketHistory(ticketNumber);
      // fetchAllRoles();
    }

    // let payload = JSON.parse(data.payload);
    // setRowPayload(payload)

  }, [ticketNumber]);


  return (
    <Fragment>
      <Row style={{ marginTop: '8px' }}>

        <ModalBody style={{ paddingTop: '14px' }}>
          <Row>
            <Col sm="12">

              <div style={{ padding: '0 12px 8px' }}>
              <Table className="custom-table table-sm" style={{ marginTop: 0 }}>
                <thead>
                  <tr>
                    <th>Role</th>
                    <th>Date</th>
                    <th>Remark</th>
                    {adminColumn && (
                      <th>Action by</th>
                    )}
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody className="mtd-bg">
                  {ticketHistoryData
                    ? ticketHistoryData?.map((item, index) => (
              
                      <>
                        <tr key={index}>
                          <td> {item.role ? item.role.toUpperCase() : ""} </td>
                          <td> {formatedDate(item?.timeStamp)} </td>
                          <td>  {item?.remark} </td>
                          {adminColumn && ( 
                            <td>  
                              {getFromLocalStorage("user").user_id ==
                                item?.approverId ? (
                                  <span className="badge badge-primary ">
                                      {item?.approverName}
                                  </span>
                                ) : (
                                  item?.approverName
                                )}
                            </td>
                                )}
                          <td> {item?.status.toLowerCase() ===
                            "approved to up" ? (
                            <div className="badge badge-success ">
                              Approved To Up
                            </div>
                          ) : item?.status.toLowerCase() ===
                            "approved" ? (
                            <div className="badge badge-success ">
                              Approved
                            </div>
                          ) : item?.status.toLowerCase() ===
                            "rejected to down" ? (
                            <div className="badge badge-danger ">
                              Rejected To Down
                            </div>
                          ) : item?.status.toLowerCase() ===
                            "rejected" ? (
                              !rejectedFlag &&  (setRejectedFlag(true)), 
                            <div className="badge badge-danger ">
                              Rejected
                            </div>
                          ) : (
                            <div className="badge badge-primary ">
                              Pending
                            </div>
                          )} </td>
                        </tr>

                      </>
                    ))
                    : "Fetching...."
                  }
                  {ticketHierarchyLeft?.map((item, index) => (
                    <>
                      <tr key={index}>
                        <td> {item ? item.toUpperCase() : ""}</td>
                        <td> {""}</td>
                        <td> {""}</td>                        
                        {adminColumn && ( 
                          <td> {""}</td>
                        )}
                        <td>
                          {!rejectedFlag && (
                            <div className="badge badge-warning">
                              Pending
                            </div>
                          )}
                        </td>

                      </tr>


                    </>
                  ))}
                </tbody>
              </Table>
              </div>


            </Col>
          </Row>
        </ModalBody>

      </Row>
    </Fragment>
  );

}

export default TicketHistory;